//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SwapcardLoginModal',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loginUrl: {
      type: String,
      default: '',
    },
  },

  computed: {
    resolvedLoginUrl() {
      if (this.loginUrl) return this.loginUrl;
      const slug = this.$root.eventSlug || '';
      if (!slug) return '#';
      return `https://myevents.tasb.org/login?redirect_url=${encodeURIComponent(`https://myevents.tasb.org/event/${slug}`)}`;
    },

    iosDownloadUrl() {
      return this.$root.swapcardAppDownloadUrlIos || '';
    },

    androidDownloadUrl() {
      return this.$root.swapcardAppDownloadUrlAndroid || '';
    },
  },

  watch: {
    visible(isVisible) {
      if (isVisible) {
        this._focusTrigger = document.activeElement;
        document.addEventListener('keydown', this.handleKeydown);
        document.body.style.overflow = 'hidden';
        this.$nextTick(() => {
          const focusable = this.$refs.dialog && this.$refs.dialog.querySelector('a[href], button');
          if (focusable) focusable.focus();
        });
      } else {
        document.removeEventListener('keydown', this.handleKeydown);
        document.body.style.overflow = '';
        if (this._focusTrigger) {
          this._focusTrigger.focus();
          this._focusTrigger = null;
        }
      }
    },
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
    document.body.style.overflow = '';
  },

  methods: {
    close() {
      this.$emit('close');
    },

    handleKeydown(e) {
      if (e.key === 'Escape') {
        this.close();
        return;
      }
      if (e.key === 'Tab' && this.$refs.dialog) {
        const focusable = Array.from(
          this.$refs.dialog.querySelectorAll('a[href], button:not([disabled])')
        );
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    },
  },
};
